export default __webpack_public_path__ + "static/media/SamPaddle.3bd2c374.jpg";